import {
  createSchedule,
  updateSchedule,
  deleteSchedule,
  fetchScheduleTypes,
} from './legup-schedules.service';

export default {
  namespaced: true,

  state: {
    scheduleTypes: [],
  },

  mutations: {
    setScheduleTypes: (state, types) => {
      state.scheduleTypes = types;
    },
  },

  actions: {
    async createSchedule({ commit, dispatch }, params) {
      try {
        const data = await createSchedule(params);
        commit('legupAgeGroups/addSchedule', data.schedule, { root: true });
        dispatch(
          'notifications/addToastSuccess',
          { text: 'New schedule created' },
          { root: true },
        );
      } catch (error) {
        dispatch('notifications/addToastError', { text: 'Could not create schedule', error }, { root: true });
      }
    },

    async fetchScheduleTypes({ commit, dispatch }) {
      try {
        const types = await fetchScheduleTypes();
        commit('setScheduleTypes', types);
      } catch (error) {
        dispatch('notifications/addToastError', { text: 'Could not fetch schedule types', error }, { root: true });
      }
    },

    async updateSchedule({ commit, dispatch }, { params, id }) {
      try {
        const data = await updateSchedule(params, id);
        commit('legupAgeGroups/updateSchedule', data.schedule, { root: true });
        dispatch(
          'notifications/addToastSuccess',
          { text: 'Your edits have been saved.' },
          { root: true },
        );
      } catch (error) {
        dispatch('notifications/addToastError', { text: 'Could not update schedule', error }, { root: true });
      }
    },

    async deleteSchedule({ commit, dispatch }, { id, ageGroupId }) {
      try {
        await deleteSchedule(id);
        commit('legupAgeGroups/deleteSchedule', { scheduleId: id, ageGroupId }, { root: true });
        dispatch(
          'notifications/addToastSuccess',
          { text: 'Your schedule has been deleted.' },
          { root: true },
        );
      } catch (error) {
        dispatch('notifications/addToastError', { text: 'Could not delete schedule', error }, { root: true });
      }
    },
  },
};
